// utilities
export { provideDyteDesignSystem } from './utils/provide-design-system';
export { extendConfig, generateConfig } from './utils/config';
export { sendNotification } from './utils/notification';
export { generateBackgroundColors, generateBrandColors } from './theme/colors';
export { DyteUIContext } from './lib/context-provider/ui-context';
import DyteUIProvider from './utils/DyteUIProvider';
export { DyteUIProvider };
export { Theme } from './theme/index';
// types
export { UIConfig } from './types/ui-config';
export {
  States,
  Notification,
  Size,
  UserPreferences,
  PollObject,
} from './types/props';

// UIConfig, Icon Pack, i18n and Notification Sounds
export { defaultConfig } from './lib/default-ui-config';
export { IconPack, defaultIconPack } from './lib/icons';
export { LangDict, defaultLanguage, DyteI18n, useLanguage } from './lib/lang';
export { Sound, default as DyteNotificationsAudio } from './lib/notification';
